module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Octant","short_name":"Octant","start_url":"/","background_color":"#1428a0","theme_color":"#1428a0","display":"minimal-ui","icon":"static/assets/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7b41c2c447eab67d3aa4dfbe2241ff9a"},
    }]
